module.exports = __webpack_public_path__ + "img/bodega-usuario.2eb08178.png";